import { render, staticRenderFns } from "./SequenceDiagram.vue?vue&type=template&id=e2d4f4d2"
import script from "./SequenceDiagram.vue?vue&type=script&lang=js"
export * from "./SequenceDiagram.vue?vue&type=script&lang=js"
import style0 from "./SequenceDiagram.vue?vue&type=style&index=0&id=e2d4f4d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports